module.exports = __webpack_public_path__ + "static/img/64.959bacfe.gif";